import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { EvolutionParams } from '@/types/api';

export function useViewsEvolution(params: EvolutionParams, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: analyticsKeys.viewsEvolution(params),
    queryFn: () => analyticsApi.viewsEvolution(params),
    staleTime: STALE_TIMES.veryLong,
    gcTime: GC_TIMES.veryLong,
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? Boolean(params.accountId || params.identityId),
  });
}
